import { render, staticRenderFns } from "./examHistoryDetail.vue?vue&type=template&id=167b3460&scoped=true&"
import script from "./examHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./examHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./examHistoryDetail.vue?vue&type=style&index=0&id=167b3460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b3460",
  null
  
)

export default component.exports